import { useState, useEffect } from "react";
import {
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { firestore } from "../shared/FirebaseConfig"; // Import the Firestore instance
import { useUser } from "../shared/UserContext";

const useFetchStudents = (classId) => {
  const [students, setStudents] = useState([]);
  const { schoolId } = useUser();

  useEffect(() => {
    const fetchStudents = async () => {
      try {
        if (!classId || !schoolId) {
          return;
        }

        const studentsCollectionRef = collection(firestore, "students");
        // schoolId scopes the query so the security rules can authorize it (same-school);
        // the teacher always shares the school of any class they can open.
        const q = query(
          studentsCollectionRef,
          where("schoolId", "==", schoolId),
          where("enrolledClasses", "array-contains", classId)
        );
        const querySnapshot = await getDocs(q);

        const studentsData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

setStudents(studentsData);
      } catch (error) {
        console.error("Error fetching students:", error);
        setStudents([]); // Reset students to an empty array in case of an error.
      }
    };

    fetchStudents();
  }, [classId, schoolId]);

  return { students, setStudents };
};

export default useFetchStudents;
